document.addEventListener('DOMContentLoaded', function() {
  // Select all anchor tags that link to an on-page ID
  const anchorLinks = document.querySelectorAll('.tab_header_section li a');

  // Function to handle the active state
  function handleActiveClass(event) {
    // Optional: Prevent the default jump-to-anchor behavior
    event.preventDefault();

    // Find the currently active element and remove the class
    // const currentActive = document.querySelector('.active');
    // if (currentActive) {
    //   currentActive.classList.remove('active');
    // }

    document.querySelectorAll('.tab_header_section li a').forEach(link => {
      link.classList.remove('active');
    });
    // --- Step 2: Clean up ALL content tabs based on your specific selector ---
    // Find every content tab and remove its 'active' class.
    document.querySelectorAll('.tab_content_section .single_tab').forEach(tab => {
      tab.classList.remove('active');
    });

    const clickedLink = event.currentTarget;
    clickedLink.classList.add('active');

    // Get the ID from the clicked link's href attribute
    const targetId = event.currentTarget.getAttribute('href');

    
    // Find the target element using the ID
    const targetElement = document.querySelector(targetId);
    

    // Add the 'active' class to the target element if it exists
    if (targetElement) {      
      targetElement.classList.add('active');
      if(targetElement.classList.contains('slider_view'))
      {
          setTimeout(function(){
            
                // initFlickity('.tab_content_section .single_tab');
                initFlickity('.tab_content_section .single_tab:not(.active)',true);
                initFlickity('.tab_content_section .single_tab.active',false);              
          }, 10);
      }  
      // setTimeout(function(){ 
      //   initFlickity('.tab_content_section .single_tab:not(.active)');
      // }, 200);
    }
  }

  // Add a click event listener to each anchor link
  anchorLinks.forEach(link => {
    link.addEventListener('click', handleActiveClass);
  });


  function initFlickity(selector,destroy=false) {

  const sliders = document.querySelectorAll(selector);
  
            sliders.forEach((slider, index) => {
                // Check if it's already initialized to prevent errors
                let flkty = Flickity.data(slider);
                if(destroy && flkty)
                {
                   flkty.destroy();
                }

                if (!flkty && destroy==false) {
                    new Flickity(slider,{ "cellAlign": "left", "contain": true, "wrapAround": true });                    
                }

                // if (!flkty) {
                //     new Flickity(slider);                    
                // }
                // else{
                //      flkty.destroy();
                // }
            })
}
});
